import { gql } from 'graphql-request'

export const UNPUBLISH_MAIN_BANNER_LIST = gql`
  mutation UnpublishMainBanners(
    $ids: [Int!]!
    $displayType: MainBannerDisplayType!
  ) {
    unPublishMainBanners(ids: $ids, displayType: $displayType) {
      id
      web
      android
      ios
      isActiveWeb
      isActiveIos
      isActiveAndroid
      coverImgPath
      linkWeb
      linkIos
      linkAndroid
      description
      startPublishedAt
      endPublishedAt
      runningNo
    }
  }
`
